import React from "react";

import { Form, Space, Typography } from "antd";
import ButtonComponent from "../Button/Button";
import IntegerInput from "../IntergerInput";
import FormInput from "../FormInput";

import { LeftOutlined, RightOutlined } from '@ant-design/icons';

const { Text, Link } = Typography;


const ForgotPassword = ({ ...props }) => {
    return (
        <Space direction="vertical" size="middle" style={{ width: "100%" }}>
            <Text type="secondary">
                A six digit OTP was sent to <Text strong>{props.email}</Text>
            </Text>
            <Form
                layout="vertical"
                className="form-new"
                onFinish={props.onFinish}
            >

                <Form.Item
                    label="Enter OTP"
                    name="otp"
                    rules={[{ required: true, message: "OTP is required" },
                    {
                        pattern: /^\d{6}$/,
                        message: "OTP must be a 6-digit number",
                    },
                    ]}
                >
                    <IntegerInput
                        maxLength={6}
                        placeholder="Enter 6-digit OTP"
                        autoComplete="one-time-code"
                    />
                </Form.Item>

                <FormInput
                    label="New Password"
                    name="newPassword"
                    type="password"
                    placeholder="Enter New Password"
                    rules={[
                        { required: true, message: "New Password is required" },
                        { validator: props.validatePassword }
                    ]}
                />

                <FormInput
                    label="Confirm Password"
                    name="confirmPassword"
                    type="password"
                    placeholder="Enter Confirm Password"
                    rules={[
                        { required: true, message: "Confirm Password is required" },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue("newPassword") === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error("Passwords do not match"));
                            }
                        })
                    ]}
                />

                <Form.Item>
                    <Text type="secondary" style={{ fontSize: 13 }}>
                        A password must contain at least 1 capital letter, 1 small letter, 1 number, 1 special character (#,@,%,!,&amp;,\*,\_,+,?, etc). Minimum 8 characters and maximum 20 characters.
                    </Text>
                </Form.Item>
                {/* OTP Input Fields can be added here */}
                <Form.Item>
                    <ButtonComponent
                        text={"Save"}
                        htmlType="submit"
                        className="login-card-new__button"
                        loading={props.loading}
                        icon={<RightOutlined />}
                    />
                </Form.Item>
            </Form>
            {props.timer > 0 ? (
                <Text type="">
                    1 {props.timer > 0 ? `in ${props.timer}s` : '00:00'}
                </Text>) : (
                <Text type="secondary">
                    Didn't receive the OTP?{' '}
                    <Link onClick={props.handleResendOtp} disabled={props.timer > 0}>
                        Resend OTP {props.timer > 0 ? `in ${props.timer}s` : ''}
                    </Link>
                </Text>)}
            <Link onClick={props.goBackOnClick} style={{ display: "block", textAlign: "center" }}><LeftOutlined /> {props.goBackLinkLable}</Link>
        </Space>
    );
}

export default ForgotPassword;